import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";

const cardIcons = {
	mc: "fa-brands fa-cc-mastercard",
	visa: "fa-brands fa-cc-visa",
	amex: "fa-brands fa-cc-amex",
	discover: "fa-brands fa-cc-discover",
};

const PaymentMethodListItem = ({ paymentMethod }) => {
	const {
		card: { brand, nameOnCard, expMonth, expYear, last4 },
	} = paymentMethod;

	const cardIcon = cardIcons[brand] || "fa-solid fa-credit-card";

	return (
		<Card className="w-full rounded-20 shadow cursor-pointer">
			<div className="p-10">
				<div className="flex flex-1 flex-col relative overflow-hidden px-8">
					<Typography>
						<i className={cardIcon} />
						<span className="font-semibold mx-2">Card ending in :</span>
						{last4}
					</Typography>
					<Typography color="todo-title text-14 font-medium">
						<span className="font-semibold mr-2">Name on card :</span>
						<span className="text-slate-500">{nameOnCard}</span>
					</Typography>
				</div>
				<div className="px-8"></div>
				<div className="px-8">
					<Typography className="todo-title text-14 font-medium">
						<span className="font-semibold mr-2">Expires :</span>
						{expMonth}/{expYear}
					</Typography>
				</div>
			</div>
		</Card>
	);
};

export default PaymentMethodListItem;
